import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowUpLeft = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M15.635 6.926a1.5 1.5 0 0 1-.325 1.635l-2.314 2.314 4.564 4.565a1.5 1.5 0 0 1-2.121 2.12l-4.565-4.564-2.314 2.315A1.5 1.5 0 0 1 6 14.25V7.5A1.5 1.5 0 0 1 7.5 6h6.75a1.5 1.5 0 0 1 1.385.925'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowUpLeft)
export default ForwardRef
